export default "__VITE_ASSET__COxhKsdV__"